import { useState, useEffect, useRef } from "react";
import { HiChevronDown, HiOutlineX, HiOutlineFilter } from "react-icons/hi";

const RangeFilter = ({
    label = "Intervalo",
    min,
    max,
    onChange,
    prefix = "",
    IconComponent = HiOutlineFilter,
}) => {
    const [open, setOpen] = useState(false);
    
    const [localMin, setLocalMin] = useState(min || "");
    const [localMax, setLocalMax] = useState(max || "");
    
    const ref = useRef(null);

    useEffect(() => {
        setLocalMin(min || "");
        setLocalMax(max || "");
    }, [min, max]);

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                if (open) applyChanges();
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, localMin, localMax]);

    const applyChanges = () => {
        if (localMin !== (min || "") || localMax !== (max || "")) {
            onChange({ min: localMin, max: localMax });
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            setOpen(false);
            applyChanges();
        }
    };

    const clear = (e) => {
        e.stopPropagation();
        setLocalMin("");
        setLocalMax("");
        onChange({ min: "", max: "" });
        setOpen(false);
    };

    const hasValue = (localMin !== "" && localMin !== null) || (localMax !== "" && localMax !== null);

    return (
        <div ref={ref} className="relative font-montserrat">
            <button
                onClick={() => setOpen(!open)}
                className={`h-10 flex items-center gap-2 px-3 rounded-lg border transition text-sm
                ${hasValue 
                    ? "bg-blue-50 border-blue-200 text-blue-700" 
                    : "bg-slate-50 border-slate-200 text-slate-600 hover:bg-slate-100"}`}
            >
                <IconComponent className={hasValue ? "text-blue-500" : "text-slate-400"} size={18} />
                
                <span className="font-medium truncate max-w-[150px]">
                    {hasValue
                        ? `${prefix} ${localMin || "0"} - ${localMax || "..."}`
                        : label}
                </span>

                {hasValue ? (
                    <div 
                        onClick={clear} 
                        className="hover:bg-blue-200 rounded-full p-0.5 ml-1 transition-colors cursor-pointer"
                    >
                        <HiOutlineX size={14} />
                    </div>
                ) : (
                    <HiChevronDown className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
                )}
            </button>

            {/* DROPDOWN */}
            {open && (
                <div className="absolute z-50 mt-2 p-4 bg-white rounded-lg shadow-xl border border-slate-100 w-64 flex flex-col gap-3 animate-fadeIn">
                    <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        Definir {label}
                    </p>
                    
                    <div className="flex items-center gap-2">
                        {/* Input Min */}
                        <div className="flex-1 relative">
                            <label className="text-[10px] text-slate-400 font-bold ml-1">MÍNIMO</label>
                            <div className="relative">
                                {prefix && <span className="absolute left-2 top-2 text-xs text-slate-400">{prefix}</span>}
                                <input
                                    type="number"
                                    value={localMin}
                                    onChange={(e) => setLocalMin(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    placeholder="0"
                                    className={`w-full border border-slate-300 rounded px-2 py-1.5 text-sm focus:outline-none focus:border-blue-500 transition-colors
                                    ${prefix ? "pl-7" : ""}`}
                                />
                            </div>
                        </div>

                        <span className="text-slate-300 mt-5 font-light">—</span>

                        {/* Input Max */}
                        <div className="flex-1 relative">
                            <label className="text-[10px] text-slate-400 font-bold ml-1">MÁXIMO</label>
                            <div className="relative">
                                {prefix && <span className="absolute left-2 top-2 text-xs text-slate-400">{prefix}</span>}
                                <input
                                    type="number"
                                    value={localMax}
                                    onChange={(e) => setLocalMax(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    placeholder="..."
                                    className={`w-full border border-slate-300 rounded px-2 py-1.5 text-sm focus:outline-none focus:border-blue-500 transition-colors
                                    ${prefix ? "pl-7" : ""}`}
                                />
                            </div>
                        </div>
                    </div>

                    <button
                        onClick={() => { applyChanges(); setOpen(false); }}
                        className="w-full bg-blue-600 text-white text-xs font-bold py-2 rounded hover:bg-blue-700 transition-colors shadow-sm mt-1"
                    >
                        APLICAR
                    </button>
                </div>
            )}
        </div>
    );
};

export default RangeFilter;